import useFetchUserInfo from './useFetchUserInfo';
export function useHasGate(gate) {
  const fetchUserInfo = useFetchUserInfo();
  if (!fetchUserInfo.data) {
    return {
      hasGate: null,
      loading: fetchUserInfo.loading,
      error: fetchUserInfo.error
    };
  }
  return {
    hasGate: fetchUserInfo.data.gates.includes(gate),
    loading: fetchUserInfo.loading,
    error: fetchUserInfo.error
  };
}